import { useGetPageContextTool } from "./get-page-context";
import { useFlowDesignerBuilderTools } from "./flow-designer-builder-tools";
import { useTQLTools } from "./tql-tools";
import { useAskUserTool } from "./ask-user-tool";
import { useConfirmUserTool } from "./ask-user-confirmation-tool";
import { useTungstenTools } from "./tungsten-tools";
import { useAdapterPickerTool } from "./use-adapter-picker-tool";
import { useApplicationSettingsTools } from "./application-settings-tools";
import { useToolErrorReporting } from "../hooks/use-tool-error-reporting";
import { useToolCallLogging } from "../hooks/use-tool-call-logging";

export const useStriimAITools = () => {
    useGetPageContextTool();
    useFlowDesignerBuilderTools();
    useTQLTools();
    useAskUserTool();
    useConfirmUserTool();
    useTungstenTools();
    useAdapterPickerTool();
    useApplicationSettingsTools();
    useToolErrorReporting();
    useToolCallLogging();
};
